/* eslint-disable no-console */
import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;

const preview = {
   // submit: async (formData: FormData) => {
   //    console.log('SUBMIT:', formData);
   //    const url = baseUrl + 'estimator/files/upload/scodixai';
   //    const accessToken = sessionStorage.getItem('accessToken');
   //    console.log('DATA:', JSON.stringify(Object.fromEntries(formData.entries())));
   //    await axios.post(url, formData, {
   //       headers: {
   //          Authorization: `Bearer ${accessToken}`, // Add Bearer token here
   //       },
   //    });
   // },

   fetchThreeJSImage: async (fileName: string, filePath: string) => {
      const url =
         baseUrl +
         `estimator/files/download?bucket=eu-scodix-ai-output-jobs&filename=${filePath}/${fileName}`;
      const accessToken = sessionStorage.getItem('accessToken');
      try {
         const response = await axios.get(url, {
            headers: {
               Authorization: `Bearer ${accessToken}`,
               'Content-Type': "'application/octet-stream'",
            },
            responseType: 'arraybuffer',
         });
         return response;
      } catch (error) {
         console.error('Fetching ThreeJSColoredImg error:', error);
         throw error;
      }
   },
};

export default preview;
